"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointColorEnum = exports.OffsetType = exports.NivoColorScheme = exports.CurveStyle = void 0;
var CurveStyle;
(function (CurveStyle) {
    CurveStyle["BASIC"] = "basis";
    CurveStyle["CARDINAL"] = "cardinal";
    CurveStyle["CATMUL_ROM"] = "catmullRom";
    CurveStyle["LINEAR"] = "linear";
    CurveStyle["MONOTONE_X"] = "monotoneX";
    CurveStyle["MONOTONE_Y"] = "monotoneY";
    CurveStyle["NATURAL"] = "natural";
    CurveStyle["STEP"] = "step";
    CurveStyle["STEP_AFTER"] = "stepAfter";
    CurveStyle["STEP_BEFORE"] = "stepBefore";
})(CurveStyle = exports.CurveStyle || (exports.CurveStyle = {}));
var NivoColorScheme;
(function (NivoColorScheme) {
    NivoColorScheme["NIVO"] = "nivo";
    NivoColorScheme["CATEGORY_10"] = "category10";
    NivoColorScheme["ACCENT"] = "accent";
    NivoColorScheme["DARK2"] = "dark2";
    NivoColorScheme["PAIRED"] = "paired";
    NivoColorScheme["PASTEL_1"] = "pastel1";
    NivoColorScheme["PASTEL_2"] = "pastel2";
    NivoColorScheme["SET_1"] = "set1";
    NivoColorScheme["SET_2"] = "set2";
    NivoColorScheme["SET_3"] = "set3";
    NivoColorScheme["BROWN_BLUE_GREEN"] = "brown_blueGreen";
    NivoColorScheme["PURPLE_RED_GREEN"] = "purpleRed_green";
    NivoColorScheme["PINK_YELLOW_GREEN"] = "pink_yellowGreen";
    NivoColorScheme["PURPLE_ORANGE"] = "purple_orange";
    NivoColorScheme["RED_BLUE"] = "red_blue";
    NivoColorScheme["RED_GREY"] = "red_grey";
    NivoColorScheme["RED_YELLOW_BLUE"] = "red_yellow_blue";
    NivoColorScheme["RED_YELLOW_GREEN"] = "red_yellow_green";
    NivoColorScheme["SPECTRAL"] = "spectral";
    NivoColorScheme["BLUES"] = "blues";
    NivoColorScheme["GREENS"] = "greens";
    NivoColorScheme["GREYS"] = "greys";
    NivoColorScheme["ORANGES"] = "oranges";
    NivoColorScheme["PURPLES"] = "purples";
    NivoColorScheme["REDS"] = "reds";
    NivoColorScheme["BLUE_GREEN"] = "blue_green";
    NivoColorScheme["BLUE_PURPLE"] = "blue_purple";
    NivoColorScheme["GREEN_BLUE"] = "green_blue";
    NivoColorScheme["ORANGE_RED"] = "orange_red";
    NivoColorScheme["PURPLE_BLUE_GREEN"] = "purple_blue_green";
    NivoColorScheme["PURPLE_BLUE"] = "purple_blue";
    NivoColorScheme["PURPLE_RED"] = "purple_red";
    NivoColorScheme["RED_PURPLE"] = "red_purple";
    NivoColorScheme["YELLOW_GREEN_BLUE"] = "yellow_green_blue";
    NivoColorScheme["YELLOW_GREEN"] = "yellow_green";
    NivoColorScheme["YELLOW_ORANGE_BROWN"] = "yellow_orange_brown";
    NivoColorScheme["YELLOW_ORANGE_RED"] = "yellow_orange_red";
})(NivoColorScheme = exports.NivoColorScheme || (exports.NivoColorScheme = {}));
var OffsetType;
(function (OffsetType) {
    OffsetType["EXPAND"] = "expand";
    OffsetType["DIVERGING"] = "diverging";
    OffsetType["NONE"] = "none";
    OffsetType["SILHOUETTE"] = "silhouette";
    OffsetType["WIGGLE"] = "wiggle";
})(OffsetType = exports.OffsetType || (exports.OffsetType = {}));
var PointColorEnum;
(function (PointColorEnum) {
    PointColorEnum["GRID_LINE_STROKE"] = "grid.line.stroke";
    PointColorEnum["LABELS_TEXT_FILL"] = "labels.text.fill";
    PointColorEnum["BACKGROUND"] = "background";
})(PointColorEnum = exports.PointColorEnum || (exports.PointColorEnum = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NoYXJ0cy91dGlscy9jb25zdGFudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsSUFBWSxVQVdYO0FBWEQsV0FBWSxVQUFVO0lBQ3BCLDZCQUFlLENBQUE7SUFDZixtQ0FBcUIsQ0FBQTtJQUNyQix1Q0FBeUIsQ0FBQTtJQUN6QiwrQkFBaUIsQ0FBQTtJQUNqQixzQ0FBd0IsQ0FBQTtJQUN4QixzQ0FBd0IsQ0FBQTtJQUN4QixpQ0FBbUIsQ0FBQTtJQUNuQiwyQkFBYSxDQUFBO0lBQ2Isc0NBQXdCLENBQUE7SUFDeEIsd0NBQTBCLENBQUE7QUFDNUIsQ0FBQyxFQVhXLFVBQVUsR0FBVixrQkFBVSxLQUFWLGtCQUFVLFFBV3JCO0FBRUQsSUFBWSxlQXNDWDtBQXRDRCxXQUFZLGVBQWU7SUFDekIsZ0NBQWEsQ0FBQTtJQUNiLDZDQUEwQixDQUFBO0lBQzFCLG9DQUFpQixDQUFBO0lBQ2pCLGtDQUFlLENBQUE7SUFDZixvQ0FBaUIsQ0FBQTtJQUNqQix1Q0FBb0IsQ0FBQTtJQUNwQix1Q0FBb0IsQ0FBQTtJQUNwQixpQ0FBYyxDQUFBO0lBQ2QsaUNBQWMsQ0FBQTtJQUNkLGlDQUFjLENBQUE7SUFDZCx1REFBb0MsQ0FBQTtJQUNwQyx1REFBb0MsQ0FBQTtJQUNwQyx5REFBc0MsQ0FBQTtJQUN0QyxrREFBK0IsQ0FBQTtJQUMvQix3Q0FBcUIsQ0FBQTtJQUNyQix3Q0FBcUIsQ0FBQTtJQUNyQixzREFBbUMsQ0FBQTtJQUNuQyx3REFBcUMsQ0FBQTtJQUNyQyx3Q0FBcUIsQ0FBQTtJQUNyQixrQ0FBZSxDQUFBO0lBQ2Ysb0NBQWlCLENBQUE7SUFDakIsa0NBQWUsQ0FBQTtJQUNmLHNDQUFtQixDQUFBO0lBQ25CLHNDQUFtQixDQUFBO0lBQ25CLGdDQUFhLENBQUE7SUFDYiw0Q0FBeUIsQ0FBQTtJQUN6Qiw4Q0FBMkIsQ0FBQTtJQUMzQiw0Q0FBeUIsQ0FBQTtJQUN6Qiw0Q0FBeUIsQ0FBQTtJQUN6QiwwREFBdUMsQ0FBQTtJQUN2Qyw4Q0FBMkIsQ0FBQTtJQUMzQiw0Q0FBeUIsQ0FBQTtJQUN6Qiw0Q0FBeUIsQ0FBQTtJQUN6QiwwREFBdUMsQ0FBQTtJQUN2QyxnREFBNkIsQ0FBQTtJQUM3Qiw4REFBMkMsQ0FBQTtJQUMzQywwREFBdUMsQ0FBQTtBQUN6QyxDQUFDLEVBdENXLGVBQWUsR0FBZix1QkFBZSxLQUFmLHVCQUFlLFFBc0MxQjtBQUVELElBQVksVUFNWDtBQU5ELFdBQVksVUFBVTtJQUNwQiwrQkFBaUIsQ0FBQTtJQUNqQixxQ0FBdUIsQ0FBQTtJQUN2QiwyQkFBYSxDQUFBO0lBQ2IsdUNBQXlCLENBQUE7SUFDekIsK0JBQWlCLENBQUE7QUFDbkIsQ0FBQyxFQU5XLFVBQVUsR0FBVixrQkFBVSxLQUFWLGtCQUFVLFFBTXJCO0FBRUQsSUFBWSxjQUlYO0FBSkQsV0FBWSxjQUFjO0lBQ3hCLHVEQUFxQyxDQUFBO0lBQ3JDLHVEQUFxQyxDQUFBO0lBQ3JDLDJDQUF5QixDQUFBO0FBQzNCLENBQUMsRUFKVyxjQUFjLEdBQWQsc0JBQWMsS0FBZCxzQkFBYyxRQUl6QiJ9